import { UserITF } from '@/types'

/**
 * Which building a session should open on when nothing has been selected yet.
 *
 * The token already carries the answer for every building-scoped user — of the
 * admin-login tokens in production, 87% have a DefaultBuildingId and the only
 * ones with no candidate at all hold ViewCompanyAllBuildings, where picking for
 * them would be wrong anyway. Reading it here is what keeps the launcher from
 * opening with no building and every scoped link dead.
 *
 * Order: the user's own default, then a sole assigned building, then whatever
 * building the token was last scoped to (QR/PIN sessions set it).
 *
 * `allowedBuildingIds` is the caller's extra restriction (the portfolio picker
 * passes the member's access list); a candidate outside it is skipped rather
 * than corrected, so this can never widen what the user can reach.
 */
export const resolveBuildingCandidate = (user?: UserITF | null, allowedBuildingIds?: string[]) => {
  const context = user?.UserContext
  const access = context?.AccessBuildingIds
  const permitted = (id?: string) => {
    if (!id) return false
    // Assigned buildings bound the choice when the user has any: this is where
    // a stale DefaultBuildingId (111 tokens in production point outside the
    // user's access) gets dropped in favour of the next candidate.
    if (access?.length && !access.includes(id)) return false
    if (allowedBuildingIds?.length && !allowedBuildingIds.includes(id)) return false
    return true
  }
  const soleAccess = access?.length === 1 ? access[0] : undefined
  return [user?.Preference?.DefaultBuildingId, soleAccess, context?.CurrentBuildingId].find(permitted)
}
